export default __webpack_public_path__ + "static/media/feintattack2.0279b0d2.png";